import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  GET_NOTIFICATIONS_ASYNC,
  RESTORE_NOTIFICATIONS_ASYNC,
  UPDATE_NOTIFICATIONS_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case GET_NOTIFICATIONS_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case GET_NOTIFICATIONS_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case GET_NOTIFICATIONS_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case GET_NOTIFICATIONS_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_NOTIFICATIONS_ASYNC.INITIATE:
        return { ...state, loader: true, data: action.payload.data }
      case UPDATE_NOTIFICATIONS_ASYNC.SUCCESS:
        return { ...state, error: null, loader: false }
      case UPDATE_NOTIFICATIONS_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case UPDATE_NOTIFICATIONS_ASYNC.CANCEL:
        return { ...state, loader: false }
      case RESTORE_NOTIFICATIONS_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case RESTORE_NOTIFICATIONS_ASYNC.SUCCESS:
        return { ...state, error: null, loader: false }
      case RESTORE_NOTIFICATIONS_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case RESTORE_NOTIFICATIONS_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
